import {
  UPDATE_FILTER,
  RESET_FILTER,
} from './albumFolderShutterbugFilterActions';
import { OWNER_STATUS_FILTER_ENUM } from '../constants';
import { SORT_DIRECTION } from '../../../../../../../constants/sort';

export const initialState = {
  owner_status: OWNER_STATUS_FILTER_ENUM.ALL,
  sort: {
    field: 'CREATED_AT',
    direction: SORT_DIRECTION.DESC,
  },
  search_query: '',
};

const albumFolderShutterbugFilterReducer = (
  state = initialState,
  action = {},
) => {
  switch (action.type) {
    case UPDATE_FILTER:
      return {
        ...state,
        ...action.filter,
      };

    case RESET_FILTER: {
      return { ...initialState };
    }

    default:
      return state;
  }
};

export default albumFolderShutterbugFilterReducer;
